import type { Annotation } from "../api/types";
import { isActivityLabel, activityLevel } from "./activityLabels.ts";
export function adjacentChapter(annotations: Annotation[], time: number, direction: -1 | 1) {
  const eligible = annotations.filter(a => isActivityLabel(a) && a.review_status !== "rejected" &&
    (direction > 0 ? a.start_ns > time + 1_000_000 : a.start_ns < time - 1_000_000));
  return eligible.sort((a,b) => direction * (a.start_ns-b.start_ns) ||
    Number(activityLevel(a) === "context") - Number(activityLevel(b) === "context"))[0];
}
export function dragInterval(start: number, end: number, delta: number, mode: "start" | "end" | "move", range: [number,number]) {
  const clamp = (v:number,lo:number,hi:number) => Math.round(Math.max(lo,Math.min(hi,v)));
  const minimum = Math.min(1_000_000,end-start);
  if (mode === "start") return {start_ns:clamp(start+delta,range[0],end-minimum),end_ns:end};
  if (mode === "end") return {start_ns:start,end_ns:clamp(end+delta,start+minimum,range[1])};
  const a = clamp(start+delta,range[0],range[1]-(end-start));
  return {start_ns:a,end_ns:a+end-start};
}
export const isMac = (platform = navigator.platform) => /Mac|iPhone|iPad/.test(platform);

/** Preserve old/manual overlaps, but give each interval its own visible track. */
export function chapterLanes(annotations: Annotation[]) {
  return (["context","activity"] as const).flatMap(level=>{
    const tracks:Annotation[][]=[[]];
    const items=annotations.filter(a=>isActivityLabel(a)&&a.review_status!=="rejected"&&activityLevel(a)===level).sort((a,b)=>a.start_ns-b.start_ns);
    for(const a of items) {
      let track=tracks.find(t=>!t.length || (t.at(-1)!.end_ns ?? t.at(-1)!.start_ns+500_000_000)<=a.start_ns);
      if(!track) {track=[];tracks.push(track);}track.push(a);
    }
    return tracks.map((items,i)=>({id:`${level}-${i}`,label:(level==="context"?"Context":"Activity")+(i?` · ${i+1}`:""),items}));
  });
}
